import { render, staticRenderFns } from "./GoogleSerpSimulator.vue?vue&type=template&id=cdc42a18&scoped=true"
import script from "./GoogleSerpSimulator.vue?vue&type=script&lang=js"
export * from "./GoogleSerpSimulator.vue?vue&type=script&lang=js"
import style0 from "./GoogleSerpSimulator.vue?vue&type=style&index=0&id=cdc42a18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc42a18",
  null
  
)

export default component.exports